import { Terminal } from 'lucide-react';
import clsx from 'clsx';
import { v4 as uuidv4 } from 'uuid';

import { EnvironmentId } from '@/react/portainer/environments/types';
import { baseHref } from '@/portainer/helpers/pathHelper';
import { requestChangeConfirmation } from '@/react/portainer/policies/utils/change-confirmation/requestChangeConfirmation';

import { Button } from '@@/buttons';

import { useSidebarState } from '../useSidebarState';
import { SidebarTooltip } from '../SidebarItem/SidebarTooltip';

interface Props {
  environmentId: EnvironmentId;
}

export function KubectlShellButton({ environmentId }: Props) {
  const { isOpen: isSidebarOpen } = useSidebarState();

  async function handleOpen() {
    if (!(await requestChangeConfirmation())) {
      return;
    }

    const url = window.location.origin + baseHref();
    const windowName = `kubectl-shell-${environmentId}-${uuidv4()}`;

    window.open(
      `${url}#!/${environmentId}/kubernetes/kubectl-shell`,
      windowName,
      'width=800,height=600'
    );
  }

  const button = (
    <Button
      color="primary"
      size="small"
      data-cy="k8sSidebar-shellButton"
      onClick={handleOpen}
      className={clsx('sidebar', !isSidebarOpen && '!p-1')}
      icon={Terminal}
    >
      {isSidebarOpen ? 'kubectl shell' : ''}
    </Button>
  );

  return (
    <>
      {!isSidebarOpen && (
        <SidebarTooltip
          content={
            <span className="text-sm whitespace-nowrap">Kubectl Shell</span>
          }
        >
          <span className="flex w-full justify-center">{button}</span>
        </SidebarTooltip>
      )}
      {isSidebarOpen && button}
    </>
  );
}
